import { Box, CircularProgress, Grid } from "@mui/material";

import StatCard from "../../components/Dashboard/StatCard";
import Title from "../../components/ReusableComponents/title";
import BalanceChart from "../../components/Charts/BalanceChart";
import HeadAndDesc from "../../components/ReusableComponents/HeadAndDesc";

import compicon from "../../assets/images/competetionicon.svg";
import fundingicon from "../../assets/images/fundingicon.svg";
import lossicon from "../../assets/images/lossicon.svg";
import winicon from "../../assets/images/winicon.svg";
import winnericon from "../../assets/images/CurrentWinner.svg";
import total from "../../assets/images/total.svg";
import competitionAd from "../../assets/images/competitionAd.png";
import "./style.scss";

import React, { useEffect } from "react";
import Table from "./Table";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { fetchUserCompetition } from "../../store/reducers/competitionReduder";
import { dollarUS } from "../../utilities/formatters";
import { Link } from "react-router-dom";
import AdsComponent from "../../components/AdsComponent";

const StatCardWrapper = (props) => {
  return (
    <Grid item xs={6} md={2}>
      <StatCard {...props} />
    </Grid>
  );
};

const CompetitionOverview = () => {
  const [LeaderStat, setLeaderStat] = useState(false);
  const [currentWinner, setCurrentWinner] = useState("");
  const [totalContentants, setContestants] = useState(0);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  function disableScroll() {
    document.body.style.overflow = "hidden";
  }
  function enableScroll() {
    document.body.style.overflow = "auto";
  }
  useEffect(() => {
    if (userData) {
      disableScroll();
      setLoading(true);
      setLeaderStat(userData);
      setLoading(false);
      enableScroll();
    }
  }, [userData]);

  const handleClick = (comp_id) => {
    if (!comp_id) return;
    setLoading(true);
    disableScroll();
    dispatch(fetchUserCompetition(comp_id))
      .then((res) => {
        setLeaderStat(res);
        setLoading(false);
        enableScroll();
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        enableScroll();
      });
  };

  return (
    <>
      {loading && (
        <div className="Overviewloader">
          <CircularProgress />
        </div>
      )}
      <Grid
        className="competition-overview"
        container
        item
        spacing={3}
        sx={{ padding: "0px 1rem" }}
      >
        <Grid className="competition-overview-boxes" container item flexDirection={"row"} spacing={3}>
          <StatCardWrapper
            StatName="Equity"
            StatDetail={
              LeaderStat &&
              LeaderStat.user &&
              LeaderStat.user.balance_equity &&
              dollarUS(LeaderStat.user.balance_equity.equity)
            }
            StatIcon={compicon}
          />
          <StatCardWrapper
            StatName="Balance"
            StatDetail={
              LeaderStat &&
              LeaderStat.user &&
              LeaderStat.user.balance_equity &&
              dollarUS(LeaderStat.user.balance_equity.balance)
            }
            StatIcon={fundingicon}
          />
          <StatCardWrapper
            StatName="P&L"
            StatDetail={
              LeaderStat &&
              dollarUS(LeaderStat?.user?.total_returns?.toFixed(2))
            }
            StatDetailSec={
              LeaderStat &&
              `${LeaderStat?.user?.return_percentage?.toFixed(2)}%`
            }
            StatIcon={lossicon}
            StatDetClass={
              LeaderStat && LeaderStat?.user?.total_returns < 0
                ? "Negative"
                : "Positive"
            }
          />
          <StatCardWrapper
            StatName="Win Rate"
            StatDetail={LeaderStat && LeaderStat?.user?.win_rate?.toFixed(2)}
            StatIcon={winicon}
            StatDetClass="Positive"
          />
          <StatCardWrapper
            StatName="Current Winner"
            StatDetail={currentWinner}
            StatIcon={winnericon}
          />
          <StatCardWrapper
            StatName="Total Contestants"
            StatDetail={totalContentants}
            StatIcon={total}
          />
        </Grid>
        <Grid container item flexDirection={"row"} spacing={3}>
          <Grid item xs={12} md={12}>
            <Box className="Container-p-20">
              <Title StyleName="StatClass" four>
                Dashboard
              </Title>
              <div>
                <BalanceChart
                  PerformanceChart={
                    LeaderStat &&
                    JSON.parse(LeaderStat.user.balance_equity_history)
                  }
                />
              </div>
            </Box>
          </Grid>
          {/* <Grid item xs={12} md={4}>
            <Box className="Container-p-20">
              <Title six>
                {" "}
                {LeaderStat && LeaderStat.user.name
                  ? LeaderStat.user.name
                  : "Dashboard Stats"}{" "}
              </Title>
              <Grid className="mtt-20" item container>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <HeadAndDesc
                    HeadTitle="Current Equity"
                    SubTitle={
                      LeaderStat &&
                      LeaderStat.user &&
                      LeaderStat.user.balance_equity &&
                      LeaderStat.user.balance_equity.equity
                    }
                  />
                  <HeadAndDesc
                    HeadTitle="Starting Balance"
                    SubTitle={LeaderStat && LeaderStat.user.account_size}
                  />
                  <HeadAndDesc
                    HeadTitle="% Return"
                    SubTitle={
                      LeaderStat &&
                      LeaderStat?.user?.return_percentage?.toFixed(2)
                    }
                  />
                  <HeadAndDesc
                    HeadTitle="Most traded product"
                    SubTitle={LeaderStat && LeaderStat.user.most_traded_product}
                  />
                  <HeadAndDesc
                    HeadTitle="Daily loss"
                    SubTitle={LeaderStat && LeaderStat.user.max_daily_loss}
                  />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <HeadAndDesc
                    HeadTitle="Current Balance"
                    SubTitle={
                      LeaderStat &&
                      LeaderStat.user &&
                      LeaderStat.user.balance_equity &&
                      LeaderStat.user.balance_equity.balance
                    }
                  />
                  <HeadAndDesc
                    HeadTitle="Cumulative PnL"
                    SubTitle={
                      LeaderStat && LeaderStat?.user?.total_returns?.toFixed(2)
                    }
                  />
                  <HeadAndDesc
                    HeadTitle="Largest winning trade"
                    SubTitle={
                      LeaderStat && LeaderStat.user.largest_winning_trade
                    }
                  />
                  <HeadAndDesc
                    HeadTitle="Max Loss"
                    SubTitle={
                      LeaderStat && LeaderStat?.user?.max_loss?.toFixed(2)
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid> */}
          <Grid
            item
            xs={12}
            display={"flex"}
            gap="20px"
            flexDirection={{ xs: "column !important", md: "row !important" }}
            className="competition-leader-table"
          >
            <Table
              xs={8}
              loading={setLoading}
              handleClick={handleClick}
              setCurrentWinner={setCurrentWinner}
              setContestants={setContestants}
              setUserData={setUserData}
            />
            <Grid xs={12} md={4}>
              <AdsComponent variant="tall" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CompetitionOverview;
